export const mapDataForBackend = (device) => ({
  deviceName: device.deviceName,
  settings: device.settings,
});
